import React from 'react';
import BBQWeather from './BBQWeather'; // Import BBQWeather component

function App() {
  return (
    <div className="App">
      <BBQWeather /> {/* Use the BBQWeather component */}
    </div>
  );
}

export default App;
